import { useTranslation } from 'react-i18next'
import { SetupWizardStep, SetupWizardStepComponent } from 'app/menu/components/TopBarV1/setupWizard/SetupWizardStep'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import N from 'utils/navigation'

export const LabourRateCTA: SetupWizardStepComponent = props => {
  const { t } = useTranslation()

  return (
    <SetupWizardStep
      {...props}
      step={{
        icon: <AttachMoneyIcon />,
        content: t('SetupWizard.LabourRateSummary'),
        buttonText: t('SetupWizard.LabourRateCTA'),
        actionOnClick: () => {
          N.push('/settings/labour-rates/new')
        }
      }}
    />
  )
}
